import * as React from 'react';

class Instructions extends React.Component {
    render() {
        return (
                <div>*If you do not see a jurisdiction listed, check back with us often for additional updates.</div>

        );
    }
}

export default Instructions;


// WEBPACK FOOTER //
// ./src/components/Instructions.js